import { AlertService } from 'sce-core';
import { Injectable } from '@angular/core';
import { SearchService } from '../../../../shared/search/search.service';
import { HttpClient } from '@angular/common/http';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { ResourceService } from 'sce-core';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../../shared/search/search-constants';
import { DatePickerConfigService } from '../../../../shared/components/datepicker/datepicker-config.service';

@Injectable()
export class PickManagementFilterSearchService extends SearchService {

    constructor(protected http$: HttpClient, public searchParams: SearchParams,
        public searchStatus: SearchStatus, protected resourceService: ResourceService,
        protected userPreferenceService: UserPreferenceService, protected alertService: AlertService,
        protected dateConfigService: DatePickerConfigService) {
        super(http$, searchParams, searchStatus, resourceService, userPreferenceService, alertService, dateConfigService);
    }

    // Filter service cannot be searched directly. It should be delegated to the result search service
    public performSearch() {
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = false;
        this.publishEvent(event);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/pick-management/services/pick-management-filter-search.service.ts